<template>
  <v-container>
    <v-card>
      <v-card-title class="mx-3">
        JUZGADOS
         <v-spacer></v-spacer>
         <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          class="mr-7"
        ></v-text-field>
      </v-card-title>
      <v-btn
          color="green"
          dark
          absolute
          top
          right
          fab
          small
          @click="goToRegistrar"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-data-table
          :headers="headers"
          :items="getAllJuzgados"
          sort-by="id"
          :search="search"
          class="elevation-1 mx-3"
          :items-per-page="20"
        >
          <template v-slot:item.activo="{ item }">
            <v-icon v-if="item.deleted_at"
                class="mr-2"
                color="grey"
              >
                mdi-minus
            </v-icon>
            <v-icon v-if="!item.deleted_at"
                class="mr-2"
                color="green"
              >
                mdi-check-bold
            </v-icon>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon
              class="mr-2"
              @click="goToUpdate(item)"
              color="indigo"
            >
              mdi-pen
            </v-icon>
            <v-icon
             v-if="!item.deleted_at"
              color="red"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card>

  </v-container>
</template>

<script>
   import { mapGetters } from "vuex";
   export default {
     data() {
       return {
         dialog: false,
         search: "",
         headers: [
           { text: "Id", value:"id" ,align: "left", sortable: true },
           { text: "Nombre", value: "nombre", sortable: true },
           { text: "Clave", value: "clave", sortable: true },
           { text: "Materia", value: "materia", sortable: true },
           { text: "Municipio", value: "municipio_data.nombre", sortable: true },
           { text: "Activo", value: "activo", sortable: true },
           { text: "Acciones", value: "action", sortable: false }
         ]
       };
     },
     created() {
       this.$store.commit("SET_LAYOUT", "dashboard-layout");
       this.$store.dispatch("GET_ALL_JUZGADOS", { url: "/listJuzgados" });
     },
     methods: {
       goToRegistrar() {
         this.$router.push({ name: "RegistrarJuzgado" });
         this.dialog = true;
       },
       goToUpdate(juzgado) {
         this.$store.commit("SELECT_JUZGADO", juzgado);
         this.$router.push({ name: "UpdateJuzgado" });
         this.dialog = true;
       },
       deleteItem(item) {
         this.$swal({
           title: '¿Desea eliminar',
           text: item.nombre + '?',
           icon: 'question',
           showCancelButton: true,
           confirmButtonText: "Aceptar"
         }).then((result) => {
           if (result.value) {
             this.save(item.id);
           }
         })
       },
       save(item) {
         this.$store.dispatch("DELETE_JUZGADO",  { url: "/juzgado/" + item } ).then(res => {
            this.$store.dispatch("GET_ALL_JUZGADOS", { url: "/listJuzgados" });
            this.$swal({
              title: "Exito!!!",
              text: "Juzgado eliminado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
         });
       }
     },
     computed: {
       ...mapGetters(["getAllJuzgados"])
     }
   };
</script>
